// в константы выносим только названия мутаций/геттеров,
// которые переиспользуем/планируем переиспользовать
export const isExternalOperator = 'isExternalOperator';
export const SET_USER = 'SET_USER';
export const RESET_USER = 'RESET_USER';

const data = {
  id: null,
  role: '',
  username: '',
  email: '',
  absenceReason: '',
  ready: false,
  external: false,
  sipUrl: '',
  sipPassword: '',
  overseerTeams: [],
};

const getters = {
  isExternalOperator(state) {
    return state.role === 'OPERATOR' && state.external;
  },
};

const mutations = {
  SET_USER(state, {
    id,
    username,
    ready,
    role,
    email,
    absenceReason,
    avatarUrl,
    external,
    sipUrl,
    sipPassword,
    overseerTeams,
  }) {
    state.id = id || state.id;
    state.username = username || state.username;
    state.ready = ready || state.ready;
    state.role = role || state.role;
    state.email = email || state.email;
    state.avatarUrl = avatarUrl || state.avatarUrl;
    state.absenceReason = absenceReason || state.absenceReason;
    state.external = external || state.external;
    state.sipUrl = sipUrl || state.sipUrl;
    state.sipPassword = sipPassword || state.sipPassword;
    state.overseerTeams = overseerTeams || state.overseerTeams;
  },
  RESET_USER(state) {
    state.id = null;
    state.username = '';
    state.ready = false;
    state.role = '';
    state.email = '';
    state.absenceReason = '';
    state.avatarUrl = null;
    state.external = false;
    state.sipUrl = '';
    state.sipPassword = '';
    state.overseerTeams = [];
  },
};

const store = {
  namespaced: true,
  state: data,
  getters,
  mutations,
};

export default store;
